// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"5a2c1979","125":"86a6e64d","175":"26d406a9","217":"e2308e49","276":"be2b440d","397":"7bbed2af","461":"91f89123","488":"902404ce","606":"4e637759","892":"c9d85269","918":"6946de59"}[chunkId] + ".chunk.js";
};